import * as q from '@/services/api/request/query';
import { encodePaginatableQuery, PaginatableQuery, Query } from '@/services/api/request';
import { encodeSortableQuery, SortableQuery } from '@/services/api/request/query';

export interface ApprovalQuery extends PaginatableQuery, SortableQuery {
  search: string;
  approvers: number[];
  doneBy: number[];
  status: number[];
  type: number[];
  updatedAtStart?: Date | null;
  updatedAtEnd?: Date | null;
}

export const encodeApprovalQuery = (query: ApprovalQuery): Query => ({
  ...encodePaginatableQuery(query),
  ...encodeSortableQuery(query),
  approvers: q.numericEnums(query.approvers),
  doneBy: q.numericEnums(query.doneBy),
  search: q.string(query.search),
  status: q.numericEnums(query.status),
  type: q.numericEnums(query.type),
  updatedAtStart: q.nullableDate(query.updatedAtStart || null),
  updatedAtEnd: q.nullableDate(query.updatedAtEnd || null),
});
